export default [
  {
    path: "/rapormusteridetay",
    name: "rapormusteridetay",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "rapormusteridetay.Baslik",
      yetki: { k: [2001002] },
    },
  },
  {
    path: "/rapormusteridetay/detay/:uuid",
    name: "rapormusteridetay-detay",
    component: () => import("./Detay.vue"),
    meta: {
      public: false,
      title: "rapormusteridetay.MusteriDetay",
      yetki: { k: [2001002] },
    },
  },
]
